import { useQuery } from '@tanstack/react-query';
import API from '../../../context/API';
import type { Store } from '../store/userStoresSlice';

export const storesByMerchantQueryKey = (merchantId: string) => ['stores', 'by-merchant', merchantId] as const;

// Server-side scoped fetch for the admin merchant filter — same public
// endpoint Devices/DeviceAssignment/MerchantEarnings already use to look up
// a single merchant's stores, instead of filtering the admin-wide GET
// /stores list on the client.
export const useStoresByMerchant = (merchantId: string | undefined, enabled: boolean) => {
  return useQuery<Store[]>({
    queryKey: storesByMerchantQueryKey(merchantId || ''),
    queryFn: async () => {
      const res = await API.get(`/stores/by-merchant/${merchantId}`);
      return res.data.data || [];
    },
    enabled: enabled && !!merchantId,
    staleTime: Infinity,
  });
};
